import React, { useEffect, useState } from 'react';
import {
  getExecutedGuests,
  getIncome,
  getTotalTenants,
  getTotalUsers
} from '../../../api/sportaloka-client';
import { format, lastDayOfWeek, startOfWeek } from 'date-fns';

const DashboardCard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalTenants, setTotalTenants] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalGuests, setTotalGuests] = useState(0);
  const getData = async () => {
    try {
      const startDate = format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');
      const endDate = format(lastDayOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');
      const query = new URLSearchParams({
        start_date: startDate,
        end_date: endDate
      }).toString();
      setError(false);
      setLoading(true);
      const fetchTotalUsers = await getTotalUsers();
      const fetchTotalTenants = await getTotalTenants();
      const fetchIncome = await getIncome(query);
      const fetchGuests = await getExecutedGuests(query);
      setTotalUsers(fetchTotalUsers.data.data || 0);
      setTotalTenants(fetchTotalTenants.data.data || 0);
      setTotalGuests(fetchGuests.data.data.length);
      setTotalIncome(
        fetchIncome.data.data.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0)
      );
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="row y-gap-30 mt-4">
      <div className="col-xl-3 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
          <div className="row y-gap-20 justify-between items-center">
            <div className="col-auto">
              <div className="fw-500 lh-14">Pelanggan</div>
              <div className="text-26 lh-16 fw-600 mt-5 text-blue-1">
                {loading && !error && 'Menghitung..'}
                {!loading && error && 'Gagal'}
                {!loading && !error && totalUsers}
              </div>
              {!error && <div className="text-15 lh-14 text-light-1 mt-5">Pelanggan Aktif</div>}
              {error && (
                <div
                  onClick={getData}
                  className="text-15 lh-14 text-danger fw-bold cursor-pointer mt-5">
                  Refresh
                </div>
              )}
            </div>
            <div className="col-auto">
              <img src="/img/dashboard/icons/4.svg" alt="icon" />
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
          <div className="row y-gap-20 justify-between items-center">
            <div className="col-auto">
              <div className="fw-500 lh-14">Tenant</div>
              <div className="text-26 lh-16 fw-600 mt-5 text-blue-1">
                {loading && !error && 'Menghitung..'}
                {!loading && error && 'Gagal'}
                {!loading && !error && totalTenants}
              </div>
              {!error && <div className="text-15 lh-14 text-light-1 mt-5">Tenant Aktif</div>}
              {error && (
                <div
                  onClick={getData}
                  className="text-15 lh-14 text-danger fw-bold cursor-pointer mt-5">
                  Refresh
                </div>
              )}
            </div>
            <div className="col-auto">
              <img src="/img/dashboard/icons/1.svg" alt="icon" />
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
          <div className="row y-gap-20 justify-between items-center">
            <div className="col-auto">
              <div className="fw-500 lh-14">Tamu Terlaksana</div>
              <div className="text-26 lh-16 fw-600 mt-5 text-blue-1">
                {loading && !error && 'Menghitung..'}
                {!loading && error && 'Gagal'}
                {!loading && !error && totalGuests}
              </div>
              {!error && <div className="text-15 lh-14 text-light-1 mt-5">Jumlah Minggu ini</div>}
              {error && (
                <div
                  onClick={getData}
                  className="text-15 lh-14 text-danger fw-bold cursor-pointer mt-5">
                  Refresh
                </div>
              )}
            </div>
            <div className="col-auto">
              <img src="/img/dashboard/icons/3.svg" alt="icon" />
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-md-6">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
          <div className="row y-gap-20 justify-between items-center">
            <div className="col-auto">
              <div className="fw-500 lh-14">Pemasukan</div>
              <div className="text-26 lh-16 fw-600 mt-5 text-blue-1">
                {loading && !error && 'Menghitung..'}
                {!loading && error && 'Gagal'}
                {!loading && !error && `${totalIncome.toLocaleString()}`}
              </div>
              {!error && <div className="text-15 lh-14 text-light-1 mt-5">Total Minggu Ini</div>}
              {error && (
                <div
                  onClick={getData}
                  className="text-15 lh-14 text-danger fw-bold cursor-pointer mt-5">
                  Refresh
                </div>
              )}
            </div>
            <div className="col-auto">
              <img src="/img/dashboard/icons/2.svg" alt="icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
